import { ArcRender } from "@visactor/vrender-core/render/symbol";

import { resolveContainerBinding } from "../../../common/explicit-binding";

import { MathArcPicker, MathPickerContribution } from "../constants";

import { DefaultMathArcPicker } from "./arc-picker";

let loadArcPick = !1;

export function bindArcMathPickerContribution(container) {
    loadArcPick || (loadArcPick = !0, container.bind(MathArcPicker).toDynamicValue((() => new DefaultMathArcPicker(resolveContainerBinding(container, ArcRender)))).inSingletonScope(), 
    container.bind(MathPickerContribution).toService(MathArcPicker));
}
//# sourceMappingURL=arc-module.js.map
